import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import ActionTypes from "../../../constants/ActionTypes";
import PreBasketProductsMiddlewareProxy from "./PreBasketMiddlewareProxy";

const preBasketProductsMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  const state = store.getState();

  switch (action.type) {
  case ActionTypes.PRODUCT.SET_PRE_BASKET_PRODUCT_IN_SESSION_STORAGE:
    PreBasketProductsMiddlewareProxy.setPreBasketInSessionStorage(state, next);
    break;
  case ActionTypes.PRODUCT.SET_EDIT_MODE_IN_SESSION_STORAGE:
    PreBasketProductsMiddlewareProxy.setEditModeInSessionStorage(state, next, action.payload);
    break;
  case ActionTypes.PRODUCT.CLEAR_PRE_BASKET:
    PreBasketProductsMiddlewareProxy.clearPreBasket(next);
    break;
  case ActionTypes.PRODUCT.REMOVE_PRE_BASKET_PRODUCT:
    PreBasketProductsMiddlewareProxy.removePreBasketProduct(state, next, action.payload);
    break;
  case ActionTypes.PRODUCT.GET_PRE_BASKET:
    PreBasketProductsMiddlewareProxy.getPreBasket(state, next);
    break;
  default:
    break;
  }
};

export default preBasketProductsMiddleware;
